export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()

  const rwgToken = new URLSearchParams(window.location.search).get('rwg_token')
  if (!rwgToken) return

  // ⚠️ このパス形状は rwg-feed-batch src/lib/feed-builders/action-builder.ts が生成する
  // Action URL と対。片方だけ変えると照合が外れてサイレントに登録スキップになるためセットで保守する。
  const storeIdAlias = window.location.pathname.match(
    /^\/entry\/stores\/([^/]+)\/bookings(\/|$)/
  )?.[1]
  if (!storeIdAlias) return

  $fetch('/rwg_token', {
    baseURL: config.public.apiBaseUrl,
    method: 'POST',
    body: { rwg_token: rwgToken, store_id_alias: decodeURIComponent(storeIdAlias) },
    credentials: 'include',
  }).catch(() => {
    // 登録失敗を unhandled rejection として Sentry に流さないための握り潰し。
    // 商用 devtools に console を出さない方針のためログも置かない。
  })
})
